import { StyleSheet } from 'react-native'

export const styles = StyleSheet.create({
  footer: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    height: 72,
    justifyContent: 'flex-end',
    paddingHorizontal: 20,
  },
  labelActive: {
    fontWeight: '700',
    fontSize: 18,
    color: '#FFF',
    lineHeight: 24,
  },
  labelDisabled: {
    fontWeight: '700',
    fontSize: 18,
    color: '#99ADBA',
    lineHeight: 24,
  },
  button: {
    backgroundColor: '#00A0F3',
    borderRadius: 4,
    minWidth: 224,
    minHeight: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
  disabledBtn: {
    backgroundColor: '#E6EBEE',
    borderRadius: 4,
    minWidth: 224,
    minHeight: 56,
    justifyContent: 'center',
    alignItems: 'center',
  },
})
